exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "color-checkbox {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  margin: .1rem; }\n  color-checkbox label {\n    display: block;\n    width: 1.4rem;\n    height: 1.4rem;\n    border-radius: 50%;\n    position: relative;\n    border: 1px solid #666;\n    cursor: pointer; }\n  color-checkbox input {\n    display: none; }\n    color-checkbox input:checked + label:before {\n      content: '';\n      border: 1px solid #fff;\n      width: 1.4rem;\n      height: 1.4rem;\n      position: absolute;\n      left: -2px;\n      top: -2px; }\n  color-checkbox span {\n    display: block;\n    margin-left: .25rem; }\n", ""]);

// exports
